import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sadieSimulatorThreadQueryKey } from "@/hooks/queries/useGetSadieSimulatorThread";
import { guacHttpClient } from "@/lib/http";
import { SadieSimulatorTextRequest } from "@/types";

// A text as the tester. Sadie's reply shows up in the thread on its own.
export function useCreateAddSadieSimulatorText() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: SadieSimulatorTextRequest) => {
      await guacHttpClient.post("relationships/simulator/text", request);
    },
    onSuccess: (_data, { talentId }) => {
      void queryClient.invalidateQueries({
        queryKey: sadieSimulatorThreadQueryKey(talentId),
      });
    },
  });
}
